import { Injectable } from '@angular/core';
import { IApprovalRequestCategory } from '../model';
import { IApprovalRequestType } from '../model/approval-request-type.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  textBold(element, selectedElements, compareValue): string {
    if (!element) {
      return '';
    }

    for (let index = 0; index < selectedElements.length; index++) {
      if (selectedElements[index][compareValue] === element[compareValue]) {
        return "text-bold";
      }
    }
  }

  sortByCategoryID(categories: IApprovalRequestCategory[]) {
    return categories.sort((a, b) => (a.id > b.id) ? 1 : -1)
  }
  
  getSelectedRequestTypesCode(selectedRequestTypes: IApprovalRequestType[]): Array<string>{
    return selectedRequestTypes.map((selectedRequestType: IApprovalRequestType) => {
      return selectedRequestType.code;
    });
  }
}
